export const convertToHours = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  const [days, time] = timestamp.split('.');
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return (parseInt(days) * 24) + hours + (minutes / 60) + (seconds / 3600);
};

export const convertToDays = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  const [days, time] = timestamp.split('.');
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return parseInt(days) + (hours / 24) + (minutes / 1440) + (seconds / 86400);
};